import { render, staticRenderFns } from "./stock_relate.vue?vue&type=template&id=4df4569a&scoped=true&lang=pug&"
import script from "./stock_relate.vue?vue&type=script&lang=js&"
export * from "./stock_relate.vue?vue&type=script&lang=js&"
import style0 from "./stock_relate.vue?vue&type=style&index=0&id=4df4569a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4569a",
  null
  
)

export default component.exports